import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
var GradeRestrictionManager = function(){
	var me = this;
	//console.log("window.restrictedGrades :::",window.restrictedGrades);
	var restrictedGrades = window.restrictedGrades || [];//[1,2,3,4,9,10]; // grade ids

	this.isGradeRestricted = function(grade){
		//console.log("isMobile:::",isMobile,", isTablet::",isTablet," isBrowser:::",isBrowser);
		try{
			if(isMobile || isTablet){			
				if(restrictedGrades.indexOf(parseInt(grade)) > -1){
					return true;
				}
			}
			
			return false;
		}catch(e){		
			return false;
		}

	}
}

export default GradeRestrictionManager;


// WEBPACK FOOTER //
// ./src/util/GradeRestrictionManager.js